module.exports = __webpack_public_path__ + "img/28.8.TSS.d9ab310f.png";